var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBehance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.5 5v14h4.72c.59 0 4.66-.13 4.66-4.07 0-2.46-1.6-3.3-2.4-3.54a3 3 0 0 0 1.78-2.91c0-1.06-.14-3.48-4.22-3.48H2.5Zm11.55 1.08v1.96h6.08V6.08h-6.08ZM5.4 7.38h1.06c.25 0 1.99-.14 1.99 1.62 0 1.5-1.26 1.65-1.77 1.65H5.4V7.4Zm11.73 1.76c-3.73 0-4.63 3.36-4.63 4.92 0 5.44 7 6.94 8.76 1.77l-2.14-.45c-.54 1.86-4.06 1.59-4.06-.45h6.34c.51-2.74-.93-5.8-4.27-5.8Zm2 3.92h-4.07c.17-2.53 3.82-2.68 4.06 0Zm-13.73-.3h1.48c.63 0 2.1.1 2.1 2 0 1.85-1.85 1.85-2.14 1.85H5.4v-3.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/behance.ae3698c84030e6361fed16955dc2270a.svg";
export { ForwardRef as ReactComponent };